export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Connect-Gray-2acfe141d3aaad0e227c32f208f2c787.svg";